var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTournamentEntryBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 143,
    viewBox: "0 0 380 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 379,
    height: 142,
    rx: 15.5,
    fill: "url(#paint0_linear_4127_1962)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 379,
    height: 142,
    rx: 15.5,
    stroke: "url(#paint1_linear_4127_1962)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4127_1962",
    x1: 190,
    y1: 0,
    x2: 190,
    y2: 181.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#171516"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4127_1962",
    x1: 190,
    y1: 0,
    x2: 190,
    y2: 192.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474747",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTournamentEntryBg);
export default __webpack_public_path__ + "static/media/tournamentEntryBG.8d089c5785045e13b8bb18fbc1d9ce47.svg";
export { ForwardRef as ReactComponent };